// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle40: FC<CheckCircle40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m17.583 27.611 11.778-11.778-2.056-2.027-9.722 9.722-4.916-4.917-2.028 2.028 6.944 6.972ZM20 36.667c-2.287 0-4.444-.438-6.472-1.313-2.028-.875-3.797-2.067-5.306-3.576-1.509-1.51-2.701-3.278-3.576-5.306S3.333 22.287 3.333 20c0-2.306.438-4.472 1.313-6.5.875-2.028 2.067-3.792 3.576-5.292 1.51-1.5 3.278-2.687 5.306-3.562S17.713 3.333 20 3.333c2.306 0 4.472.438 6.5 1.313 2.028.875 3.792 2.062 5.292 3.562s2.687 3.264 3.562 5.292 1.313 4.194 1.313 6.5c0 2.287-.438 4.444-1.313 6.472-.875 2.028-2.062 3.796-3.562 5.306-1.5 1.509-3.264 2.701-5.292 3.576s-4.194 1.313-6.5 1.313Zm0-2.778c3.87 0 7.153-1.352 9.847-4.056C32.542 27.13 33.89 23.852 33.89 20c0-3.87-1.347-7.153-4.042-9.847C27.153 7.458 23.87 6.11 20 6.11c-3.852 0-7.13 1.347-9.833 4.042C7.463 12.847 6.11 16.13 6.11 20c0 3.852 1.352 7.13 4.056 9.833C12.87 32.537 16.148 33.89 20 33.89Z" />
        </svg>
    );
};

export default CheckCircle40;
